<template>
  <v-btn :disabled="disabled" icon variant="text" size="small" @click="$emit('execute')">
    <v-icon size="24" class="new-workpackage">
      {{ icon }}
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },

  emits: ['execute'],
};
</script>
